import script from "./EmailVerified.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailVerified.vue?vue&type=script&setup=true&lang=js"

import "./EmailVerified.vue?vue&type=style&index=0&id=4287ec8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4287ec8a"]])

export default __exports__